import { getAdminAxiosInstance } from "../../../api/Admin";

export const fetchMenuData = async (body) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/product/fetch-menu`, body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
export const posistMenuFetchingData = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`/product/posist-fetch-menu?store_id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
export const ManualMenuFetching = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`/product/fetch-menu-all`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const copyStoreMenu = async (body) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/store/copy-store-menu`, body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

// Queue a delta menu sync for one or many stores. Returns immediately with a
// run_id - the stores are synced by the product service's queue worker, so
// nothing here waits on them. Poll posistDeltaRunStatus with that run_id.
export const posistDeltaBulkSync = async (body) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/product/posist-delta-bulk-sync`, body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const posistDeltaRunStatus = async (runId) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`/product/posist-delta-run?run_id=${runId}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

// Whichever run is in flight right now, for the dashboard panel - which never
// started a run and so has no run_id to poll with.
//
// Unlike its siblings this hands back the HTTP status as well as the body. The
// panel polls on a timer for as long as the dashboard is open, so it has to be
// able to tell "nothing is syncing" (a 200) from "you are not allowed to ask"
// (a 403, for an admin without manage_store) - the first keeps the timer
// running, the second has to stop it for good rather than retry every few
// seconds forever. A status of 0 means the request never got an answer, which
// is a blip and keeps polling.
export const posistDeltaActiveRun = async () => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`/product/posist-delta-active`);
    return { status: response?.status ?? 0, body: response?.data };
  } catch (error) {
    return { status: error?.response?.status ?? 0, body: error?.response?.data };
  }
};
